import * as React from 'react';

import { createCtx } from '../../helpers';
import { ConfirmModalActionProps } from '../../components';

export const SHOW_CONFIRM = 'SHOW_CONFIRM';
export const HIDE_CONFIRM = 'HIDE_CONFIRM';

export type ModalAction =
	| {
			type: 'SHOW_CONFIRM';
			payload: Omit<ConfirmState, 'visible'>;
	  }
	| { type: 'HIDE_CONFIRM' };

type ConfirmState = {
	visible: boolean;
	title: string;
	message: string;
	submitAction: () => unknown;
	confirmProps?: ConfirmModalActionProps;
	cancelProps?: ConfirmModalActionProps;
};

export const initialState: ConfirmState = {
	visible: false,
	title: '',
	message: '',
	// eslint-disable-next-line @typescript-eslint/no-empty-function
	submitAction: () => {},
};

type ContextType = {
	state: ConfirmState;
	dispatch: React.Dispatch<ModalAction>;
};

export const [useModal, ModalDataProvider] = createCtx<ContextType>();
